import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const usePrinterGroups = () => {
  return useSelector(Global.selectConnectPrinters) || emptyArray;
};
